<template>
  <article id="parceiros">
    <Letreiro title="Parceiros" class="blend" :style="'background-image: url(' + require('../assets/extras/tartaruga.jpg') + ')'" />
    <section class="logos_parceiros">
      <div v-for="cliente in clientes">
        <img :src="require('../assets/parceiros/' + cliente.img)" :alt="cliente.alt" />
      </div>
    </section>
  </article>
</template>

<script>
import Letreiro from '@/components/Letreiro.vue'

export default {
  name: 'Parceiros',
  components: {
    Letreiro
  },
  data() {
    return {
      clientes: [
        {alt: "Museu da Imagem e do Som", img: "mis-logo.png"},
        {alt: "Sesc", img: "sesc-logo.png"},
        {alt: "Secretaria da cultura ", img: "CULTURA_H_Traco.png"},
        {alt: "Instituto Cultura em Movimento", img: "icem.jpg"},
        {alt: "A Próxima Companhia", img: "proxima-logo.webp"},
        {alt: "Revista Agreste", img: "agreste-logo.png"},
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {width: 100%; height: 100%;}
  .logos_parceiros {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .logos_parceiros img{
    padding: 5vh 5vw;
  }
  @media (orientation: portrait) {
    .logos_parceiros { grid-template-columns: 1fr 1fr; }
  }

  /* --- LETREIRO --- */
     .triggerParceiros h1 >>> span {
       animation-name: letreiro;
       animation-duration: 1s;
       animation-direction: reverse;
       animation-fill-mode: both;
       opacity: 0;
     }
    /* PARCEIROS */
      h1 >>> span:nth-child(1) { /* P */
       grid-column: 4;
       grid-row: 1;
       animation-delay: 0.8s;
      }
      h1 >>> span:nth-child(2) { /* a */
       grid-column: 7;
       grid-row: 1;
       animation-delay: 0.7s;
      }
      h1 >>> span:nth-child(3) { /* r */
       grid-column: 8;
       grid-row: 2;
       animation-delay: 0.6s;
      }
      h1 >>> span:nth-child(4) { /* c */
       grid-column: 1;
       grid-row: 3;
       animation-delay: 0.5s;
      }
      h1 >>> span:nth-child(5) { /* e */
       grid-column: 8;
       grid-row: 5;
       animation-delay: 0.4s;
      }
      h1 >>> span:nth-child(6) { /* i */
       grid-column: 1;
       grid-row: 5;
       animation-delay: 0.3s;
      }
      h1 >>> span:nth-child(7) { /* r */
       grid-column: 1;
       grid-row: 6;
       animation-delay: 0.2s;
      }
      h1 >>> span:nth-child(8) { /* o */
       grid-column: 8;
       grid-row: 7;
       animation-delay: 0.1s;
      }
      h1 >>> span:nth-child(9) { /* s */
       grid-column: 2;
       grid-row: 8;
       animation-delay: 0s;
      }

@media (min-width: 768px) {
/*
  ##Device = Tablets, Ipads
  ##Screen = B/w 768px to 1024px
*/
.logos_parceiros { grid-template-columns: 1fr 1fr; padding: 0; }
.logos_parceiros img {padding: 2vw;}
/* PARCEIROS */

  h1 >>> span:nth-child(2) { /* a */
   grid-column: 5;
   grid-row: 2;
   animation-delay: 0.7s;
  }
  h1 >>> span:nth-child(3) { /* r */
   grid-column: 1;
   grid-row: 3;
   animation-delay: 0.6s;
  }
  h1 >>> span:nth-child(4) { /* c */
   grid-column: 8;
   grid-row: 4;
   animation-delay: 0.5s;
  }
  h1 >>> span:nth-child(5) { /* e */
   grid-column: 5;
   grid-row: 5;
   animation-delay: 0.4s;
  }
  h1 >>> span:nth-child(6) { /* i */
   grid-column: 6;
   grid-row: 5;
   animation-delay: 0.3s;
  }
  h1 >>> span:nth-child(7) { /* r */
   grid-column: 3;
   grid-row: 6;
   animation-delay: 0.2s;
  }
  h1 >>> span:nth-child(8) { /* o */
   grid-column: 8;
   grid-row: 7;
   animation-delay: 0.1s;
  }
  h1 >>> span:nth-child(9) { /* s */
   grid-column: 2;
   grid-row: 8;
   animation-delay: 0s;
  }

}
</style>
